import React from 'react';
import { 
    FormControl, 
    FormGroup, 
    FormControlLabel, 
    Checkbox, 
    Typography, 
    Box 
} from '@material-ui/core';
import { useLeakCheckForm } from './LeakCheckFormContext';
import { CustomFieldsList } from './CustomFieldsList';

export const TankCheckSection: React.FC = () => {
    const { form, toggleTankCheckField } = useLeakCheckForm();
    
    if (!form) return null;
    
    return (
        <>
            <Typography variant="h6" gutterBottom>
                Tank Check Fields
            </Typography>
            <Typography variant="body2" color="textSecondary" paragraph>
                Configure the tank inspection fields in the form.
            </Typography>
            
            <FormControl component="fieldset">
                <FormGroup>
                    <FormControlLabel
                        control={<Checkbox 
                            checked={form.tankCheck.size} 
                            onChange={() => toggleTankCheckField('size')}
                            color="primary"
                        />}
                        label="Tank Size"
                    />
                    <FormControlLabel
                        control={<Checkbox 
                            checked={form.tankCheck.serialNumber} 
                            onChange={() => toggleTankCheckField('serialNumber')}
                            color="primary"
                        />}
                        label="Serial Number"
                    />
                    <FormControlLabel
                        control={<Checkbox 
                            checked={form.tankCheck.customerOwned} 
                            onChange={() => toggleTankCheckField('customerOwned')}
                            color="primary"
                        />}
                        label="Customer Owned"
                    />
                </FormGroup>
            </FormControl>
            
            <Box mt={4}>
                <CustomFieldsList
                    title="Custom Tank Check Fields"
                    fields={form.tankCheck.customFields}
                    sectionType="tankCheck"
                />
            </Box>
        </>
    );
};